import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import UserAppResource from './UserAppResource';

class RoleAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'Role';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'roles';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'name',
            'guardName',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            users: UserAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return [];
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return [];
    }

}

export default RoleAppResource;
